import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import FeedbackPage from '@/features/feedback/FeedbackPage';
import WarningWrapper from '@/features/warnings/WarningWrapper';
import { LoadingIndicator } from './LoadingIndicator';

const MainComponent = () => (
    <div className="overflow-hidden display-flex flex-column padding-bottom-2">
        <Suspense fallback={<LoadingIndicator />}>
            <Routes>
                <Route path="/:assetId" element={<WarningWrapper />} />
                <Route path="/feedback/:warningId" element={<FeedbackPage />} />
            </Routes>
        </Suspense>
    </div>
);

export default MainComponent;
